import { useEffect } from "react";
import { ThemeProvider as NextThemesProvider } from "next-themes";

interface ThemeProviderProps {
  children: React.ReactNode;
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  // Force light mode on mount and continuously ensure it stays light
  useEffect(() => {
    const enforce = () => {
      document.documentElement.classList.remove('dark');
      document.documentElement.classList.add('light');
      document.documentElement.style.colorScheme = 'light';
    };
    enforce();

    // Clear any stale next-themes localStorage that might set dark
    try {
      localStorage.setItem('theme', 'light');
    } catch {}

    // Observe for external changes (e.g. next-themes hydration setting dark)
    const observer = new MutationObserver(() => {
      if (document.documentElement.classList.contains('dark')) {
        enforce();
      }
    });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'style'] });

    return () => observer.disconnect();
  }, []);

  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="light"
      forcedTheme="light"
      enableSystem={false}
      disableTransitionOnChange
      storageKey="theme"
    >
      {children}
    </NextThemesProvider>
  );
}
